import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  const appLoading = document.getElementById('app-loading');
  const loadErrorTemplate = document.getElementById('app-load-error-template');
  if (!appLoading || !(loadErrorTemplate instanceof HTMLTemplateElement))
    return;
  Array.from(appLoading.childNodes)
    .filter((n) => !(n instanceof HTMLHeadingElement))
    .forEach((n) => {
      appLoading.removeChild(n);
    });
  appLoading.append(loadErrorTemplate.content);
  appLoading
    .querySelector('button')
    ?.addEventListener('click', () => location.reload());
});
